import React, { useState, useEffect } from 'react'
import { FormHelperText, TextField, Chip, Switch, Grid } from '@mui/material'
import { useInput, FieldTitle, useTranslate, useNotify } from 'react-admin'

const INCLUDE_OPTION = 'include'
const EXCLUDE_OPTION = 'exclude'

export const ChipInput = ({
  source,
  defaultValue,
  validate,
  onChange,
  routeValidation = false,
  showAllOption = false,
  ...props
}) => {
  const translate = useTranslate()
  const notify = useNotify()
  const [inputValue, setInputValue] = useState('')
  const [format, setFormat] = useState(false)
  const [selectedMode, setSelectedMode] = useState(INCLUDE_OPTION)
  const { field, fieldState } = useInput({
    source,
    validate,
    defaultValue: defaultValue || showAllOption ? { [selectedMode]: ['todas'] } : [],
  })
  const { error } = fieldState
  useEffect(() => {
    if (showAllOption) {
      knowWhatSelectModeIs(field.value)
    }
  }, [field.value])

  const knowWhatSelectModeIs = (value) => {
    let isExclude = (value) => {
      return value?.[EXCLUDE_OPTION] && value?.[EXCLUDE_OPTION].length != 0
    }
    let isInclude = (value) => {
      return value?.[INCLUDE_OPTION] && value?.[INCLUDE_OPTION].length != 0
    }
    if (isExclude(value)) {
      setSelectedMode(EXCLUDE_OPTION)
      return
    }
    if (isInclude(value)) {
      setSelectedMode(INCLUDE_OPTION)
      return
    }
  }
  const checkFormat = (value) => {
    // only accepted format 'BUE-MIA', ''BUE-MAD' or "todas"
    const regex = /^[A-Z]{3}-[A-Z]{3}$/
    return value === 'todas' || regex.test(value)
  }

  const handleAddChip = (event) => {
    let value = event.target.value
    const removeWhiteSpace = (value) => {
      return value.replace(/\s+/g, '')
    }
    value = removeWhiteSpace(value)
    let newChips = []
    if (showAllOption) {
      newChips = field.value?.[selectedMode].length > 0 ? [...field.value?.[selectedMode]] : []
    } else {
      newChips = [...field.value]
    }

    const checkIfNotEnterAValue = !value.replace(/\s/g, '')?.length
    if (checkIfNotEnterAValue) return

    const duplicatedValues = newChips.indexOf(value.trim())
    if (duplicatedValues !== -1) {
      setInputValue('')
      return
    }

    if (routeValidation && !checkFormat(value)) {
      setFormat(true)
      notify(translate(`ra.message.invalid_format`), { type: 'error' })
      return
    }

    newChips.push(value.trim())

    if (showAllOption) {
      field.onChange({ [selectedMode]: newChips })
      onChange && onChange({ [selectedMode]: newChips })
    } else {
      field.onChange(newChips)
      onChange && onChange(newChips)
    }
    setFormat(false)
    setInputValue('')
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleAddChip(event)
    } else if (field.value.length && !inputValue.length && event.key === 'Backspace') {
      const newChips = field.value.slice(0, field.value.length - 1)
      field.onChange(newChips)
      onChange && onChange(newChips)
    }
  }

  const handleDelete = (item) => {
    let newChips = []
    if (showAllOption) {
      newChips = [...field.value?.[selectedMode]]
      newChips.splice(newChips.indexOf(item), 1)
      field.onChange({ [selectedMode]: newChips })
      onChange && onChange({ [selectedMode]: newChips })
    } else {
      newChips = [...field.value]
      newChips.splice(newChips.indexOf(item), 1)
      field.onChange(newChips)
      onChange && onChange(newChips)
    }
  }

  const onChangeMode = (e) => {
    const checked = e.target.checked
    const mode = checked ? INCLUDE_OPTION : EXCLUDE_OPTION
    const newValue =
      field.value?.[selectedMode]?.length > 0 ? { [mode]: field.value?.[selectedMode] } : { [mode]: [] }
    field.onChange(newValue)
    onChange && onChange({ target: { value: newValue } })
    setSelectedMode(mode)
  }

  return (
    <>
      <Grid className='select'>
        {showAllOption && (
          <Grid className='select-switch'>
            <Switch size='small' checked={selectedMode === INCLUDE_OPTION} onChange={onChangeMode} />
            <FieldTitle label={translate(`ra.field.${selectedMode}`)} />
          </Grid>
        )}
        <TextField
          fullWidth
          className='chip-input'
          InputProps={{
            startAdornment: (showAllOption ? field.value?.[selectedMode] : field?.value)?.map((item) => (
              <Chip
                size='small'
                key={item}
                tabIndex={-1}
                label={item}
                onDelete={() => handleDelete(item)}
                style={{ marginRight: '5px' }}
              />
            )),
            value: inputValue,
            onChange: (e) => setInputValue(e.target.value),
            onKeyDown: handleKeyDown,
            onBlur: handleAddChip,
            onError: (e) => {
              checkFormat(e.target.value)
            },
          }}
          size='small'
          color={routeValidation && format ? 'error' : 'primary'}
          error={error !== undefined}
          {...props}
        />
      </Grid>

      <FormHelperText className='form-helper-text' error>
        {error?.message}
      </FormHelperText>
    </>
  )
}
